import React, { useState, useContext, useEffect } from "react";
import { RidersIcon, Space } from "../shared";
import { ToolbarIcon, Dropdown, Screen, Menu } from "./";
import { IToolbarComponentProps } from "./types";
import MainMenu from "./menu/MainMenu";
import { Auth } from "../../contexts/ridersUserContext";
import cookies from "js-cookie";
import eventBus from "../../utils/eventBus";

import { saveAs } from "file-saver";

import { FileSystem } from "./";
import {
  BackIconCircle,
  CogIcon,
  FlagIcon,
  HomeIcon,
  NotificationIcon,
  PeopleIcon,
  GlobeIcon,
  ThemeIcon,
  SettingsIcon,
  ChevronRight,
} from "../shared/icons/icons";
import { IoIosMenu } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import { idleShutDown } from "../../api";
import { FormattedMessage } from "react-intl";
import PopoverComponent from "./shared/Popover";
import Notification from "./Notification";
import { getSubCookieDomain } from "../../utils/cookies";
import { Communication } from "../../contexts/communicationContext";
import { useNotifications } from "../../contexts/notifications";
import { classNames } from "../../utils";

export const Toolbar: React.FC<IToolbarComponentProps> = ({
  setPanel,
  panel,
  className,
  theme,
  toggleTheme,
}) => {
  const [searchParams] = useSearchParams();
  const [collapsed, setCollapsed] = useState(true);

  const [open, setOpen] = useState(false);
  const [everBeenOpened, setEverBeenOpened] = useState(false);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    localStorage.setItem("ridersCollapsed", "true");
  };

  const { env, documentationRef } = useContext<any>(Screen.context);
  const { postMessage } = useContext<any>(Communication.context);
  const {
    newNotificationTrigger,
    markAsReadAll,
    markAsReadAllUIManipulation,
    unreadNotificationCount,
  } = useNotifications();

  const { projectType, userCodeFilePath, getToken, user, setContentEditMode, ridersUser } =
    useContext<any>(Auth.context);

  const { readFile, writeFile, leaveHandler } = useContext<any>(
    FileSystem.context
  );

  const [terminalStatus, setTerminalStatus] = useState<boolean>(false);

  var fileSelector: HTMLInputElement | undefined = undefined;

  const handleUpload = (
    onFileLoaded: (e: ProgressEvent<FileReader>) => void
  ) => {
    if (typeof fileSelector === "undefined") {
      fileSelector = document.createElement("input");
      fileSelector.type = "file";
      fileSelector.style.display = "none";
      document.body.appendChild(fileSelector);
    }
    fileSelector.onchange = (e) => {
      if (!fileSelector?.files || fileSelector?.files?.length !== 1) return;

      let reader = new FileReader();
      reader.readAsText(fileSelector?.files[0], "UTF-8");

      reader.onload = onFileLoaded;

      reader.onerror = (e) => {
        // message.error("File could not imported", 2);
      };

      document.body.removeChild(fileSelector);
    };

    fileSelector.click();
  };

  const handleDownload = async (file_path: string, save_name: string) => {
    const code = await readFile(file_path);
    const blob = new Blob([code], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(blob, save_name);
  };

  //add post message listener

  window.addEventListener("message", (e) => {
    try {
      const data = JSON.parse(e.data);
      if (data.type === "openTerminal") {
        setTerminalStatus(true);
      }

      if (data.type === "closeTerminal") {
        setTerminalStatus(false);
      }
    } catch (error) {
      return;
    }
  });

  const pushRiders = async (
    route?: string,
    shutdown?: boolean,
    msg?: string,
    close?: boolean
  ) => {
    window.removeEventListener("beforeunload", leaveHandler);

    try {
      await leaveHandler();

      if (shutdown) {
        if (ridersUser && ridersUser.is_superuser && Number(ridersUser.id) !== Number(user.id)) {
          // Don't close someone elses session
          console.log("shutdown skipped");
        } else {
          await idleShutDown(getToken());
        }
      }
    } catch { }

    if (close) {
      window.close();
    }

    const isStaging = user?.avatar?.includes("staging");
    const isDemo = user?.cms_info?.is_demo_user;

    const url = `https://${isStaging ? "staging." : ""}riders.ai/${route ?? "dashboard"
      }${msg ? `?msg=${msg}` : ""}`;

    window.onbeforeunload = null;
    window.location.href = url;
  };

  const handleLanguageChange = (lang: string) => {
    cookies.set("accept-language", lang, { domain: getSubCookieDomain() });
    window.location.reload();
  };

  const ProfileMenu = () => {
    return (
      <Menu>
        {[
          {
            title: <FormattedMessage id="accountSettings" />,
            icon: <SettingsIcon />,
            onClick: () => pushRiders("account/settings", true),
          },

          {
            title: <FormattedMessage id="language" />,
            icon: <GlobeIcon />,
            items: [
              {
                title: "EN",
                onClick: () => handleLanguageChange("en"),
              },
              {
                title: "TR",
                onClick: () => handleLanguageChange("tr"),
              },
            ],
          },
          {
            title: <FormattedMessage id="settingsThemeOptions" />,
            icon: <ThemeIcon />,
            items: [
              {
                title: <FormattedMessage id="settingsDarkTheme" />,
                onClick: () => toggleTheme("dark"),
              },
              {
                title: <FormattedMessage id="settingsLightTheme" />,
                onClick: () => toggleTheme("light"),
              },
            ],
          },
          // {
          //   title: <FormattedMessage id='logOut'/>,
          //   onClick: () => pushRiders(undefined, true)
          // },
          user?.is_superuser && {
            title: <FormattedMessage id="editContent" />,
            icon: <MdEdit size={18} color="#05CA75" />,
            onClick: () => setContentEditMode(true),
          },
        ].filter((item) => item)}
      </Menu>
    );
  };

  const goBack = (msg?: string, close?: boolean) => {
    // Parse the original URL
    const url = new URL(window.location.href);

    // Get the 'previous' parameter
    const previousEncoded = url.searchParams.get("previous");
    if (previousEncoded) {
      let previousDecoded = decodeURIComponent(previousEncoded);
      // Remove the leading slash if it exists
      previousDecoded = previousDecoded.replace(/^\/+/, "");
      if (previousDecoded.includes("/reports") && close) {
        return pushRiders(previousDecoded, true, msg, true);
      }
      pushRiders(previousDecoded, true, msg);
    }
  };

  useEffect(() => {
    if (documentationRef.current) {
      documentationRef.current.contentWindow.postMessage(
        JSON.stringify({
          theme,
        }),
        "*"
      );
    }
  }, [theme, documentationRef]);

  useEffect(() => {
    eventBus.on("event-received", (event) => {
      if (event.type === "close-editor") {
        if (event.reason) {
          return goBack("editor-closed", false);
        }
        goBack("editor-closed");
      }
    });
  }, []);

  useEffect(() => {
    if (newNotificationTrigger > 0) {
      setOpen(true);
    }
  }, [newNotificationTrigger]);

  useEffect(() => {
    if (!everBeenOpened) {
      setEverBeenOpened(true);
    }
    if (open) {
      markAsReadAll();
    } else {
      if (everBeenOpened) {
        markAsReadAllUIManipulation();
      }
    }
  }, [open]);

  return (
    <div
      className={`h-full ${collapsed ? "w-16" : "w-[190px]"
        }  rounded-r-[30px] bg-gradient-to-r  text-white from-[#5DDDA6] to-[#5EDEA7] flex flex-col items-center space-y-1 justify-center py-8 px-0 relative pr-2 ${className}`}
    >
      <span
        onClick={() => pushRiders(undefined, true)}
        className=" cursor-pointer mb-10"
      >
        <RidersIcon width={47} height={47} color="white" />
      </span>

      {/*Module*/}
      <>
        <ToolbarIcon
          Icon={HomeIcon}
          label={collapsed ? undefined : <FormattedMessage id="homePage" />}
          active={true}
          height="h-fit"
          activeColor="fill-riders-green-dark text-riders-green"
          onClick={() => pushRiders("/dashboard", true)}
        />
      </>
      <>
        <ToolbarIcon
          Icon={PeopleIcon}
          active={false}
          height="h-fit"
          label={collapsed ? undefined : <FormattedMessage id="myClassrooms" />}
          activeColor="fill-riders-green-dark text-riders-green"
          onClick={() => pushRiders(`/dashboard/classrooms`, true)}
        />
      </>

      <>
        <ToolbarIcon
          Icon={FlagIcon}
          active={false}
          height="h-fit"
          label={collapsed ? undefined : <FormattedMessage id="competitions" />}
          activeColor="fill-riders-green-dark text-riders-green"
          onClick={() => pushRiders(`/competitions`, true)}
        />
      </>

      <ToolbarIcon
        Icon={BackIconCircle}
        height="h-fit"
        label={collapsed ? undefined : <FormattedMessage id="goBack" />}
        onClick={() => goBack(undefined, true)}
        className="bg-[#C7FFE6] !text-[#5EDEA7] hover:bg-[#78e2ad] hover:!text-white transition-all !fill-riders-green-dark hover:!fill-white"
      />

      {env === "edusim" && (
        <>
          <img src="/edusim.png" className="px-1" alt="edusim_logo" />
          <img src="/meb_logo.png" className="px-1 my-3" alt="meb_logo" />
        </>
      )}

      <Space />

      <PopoverComponent
        theme={theme}
        trigger="click"
        arrow="Hide"
        onOpenChange={setOpen}
        open={open}
        content={<Notification />}
      >
        <div className="w-full pl-5 relative hover:bg-[#78E4B6] transition-all rounded-r-xl">
          {unreadNotificationCount > 0 && (
            <div className="absolute bg-rose-500 text-background text-xs font-medium w-4 h-4 rounded-full flex items-center justify-center left-7 top-2">
              {unreadNotificationCount > 9 ? "9+" : unreadNotificationCount}
            </div>
          )}
          <span className="w-full h-fit py-3 space-x-3 flex items-center cursor-pointer">
            <NotificationIcon size={24} />
            {!collapsed && (
              <p>
                <FormattedMessage id="notifications" />
              </p>
            )}
          </span>
        </div>
      </PopoverComponent>
      <span className="w-full space-x-3 flex items-center cursor-pointer hover:bg-[#78E4B6] transition-all rounded-r-xl">
        <Dropdown
          menu={<ProfileMenu />}
          position="bottom-0 left-full"
          className="w-full"
        >
          <ToolbarIcon
            Icon={CogIcon}
            height="h-fit"
            activeColor="fill-riders-green-dark text-riders-green"
            label={collapsed ? undefined : <FormattedMessage id="settings" />}
          />
        </Dropdown>
      </span>

      {/*<Dropdown menu={<SettingsMenu handleLanguageChange={handleLanguageChange}/>} position="bottom-0 left-full">*/}
      {/*  <>*/}
      {/*    <ToolbarIcon Icon={IoSettingsOutline} />*/}
      {/*  </>*/}
      {/*</Dropdown>*/}

      {/*<ToolbarIcon Icon={GoMoon} />*/}
      <button
        className="bg-[#4BBB8A] py-5 px-1 rounded-r-md absolute top-1/2 left-full -translate-y-1/2 z-[999] opacity-60"
        onClick={toggleCollapse}
      >
        <ChevronRight className={classNames(collapsed ? "" : "rotate-180")} />
      </button>
    </div>
  );
};

const extensionClickHandler = (
  title: string,
  panel: any,
  setPanel: (panel: any) => void,
  children?: any,
  settings?: any
) => {
  if (panel.title === title) {
    setPanel({ ...panel, open: !panel.open });
  } else {
    setPanel({ title, open: true, children, settings });
  }
};
